function alphaOnly(event) {
  var key = event.keyCode;
  return ((key >= 65 && key <= 90) || key == 8);
};

// setTimeout(QuizLoad,3500);
function QuizLoad() {
  setTimeout((p)=>{
    changeClock();
    hidePrev();
    loadOptionImage();
    addImageChangeEvent();
    splitQuestion();
    showName();
    bannerText();
  },100)
}

function bannerText(){
  if(document.querySelector('[data-goto="7"]')){
    document.querySelector('.waiting-text').style.display = 'block';
    document.querySelector('.waiting-text p').style.color = 'white';
  }else{
    if(document.querySelector('.action_btn button:last-child').getAttribute('data-goto') === '4') {
      document.querySelectorAll('.option_item')[1].click();
    }
  }
}

function updateDiscount(){
   document.querySelectorAll('.product-card-wrapper').forEach(card=>{
    if(!(parseInt(localStorage.getItem('priceRange').split('-')[0]) 
         <= 
         parseInt(card.querySelector('[data-price]').getAttribute('data-price'))
          && 
        parseInt(localStorage.getItem('priceRange').split('-')[1]) 
         >
         parseInt(card.querySelector('[data-price]').getAttribute('data-price')))) {
      card.remove();
    }
    let dataCmpPrice = parseInt(card.querySelector('[data-compare-price]').getAttribute('data-compare-price'))/100;
    let dataPrice = parseInt(card.querySelector('[data-price]').getAttribute('data-price'))/100; 
  	let diffPrice = dataCmpPrice - dataPrice;
  	let discount = parseInt(diffPrice/dataCmpPrice * 100);
     
   if(discount > 0 || !(dataCmpPrice <= dataPrice) ){
      card.querySelector('.percent_discount').innerText = `${discount}% OFF`;
    }else{
      card.querySelector('[data-compare-price]').style.display = 'none';
      card.querySelector('#discount').style.display = 'none';
      
    }
    
  });
    document.querySelector('.prdCount').innerText = document.querySelectorAll('.product-card-wrapper').length;
 } 

function quizEnd(){
  setTimeout(()=>{
    document.querySelector('.prdCount').innerText = document.querySelectorAll('.product-card-wrapper').length;
    if(document.querySelectorAll('.card-wrapper').length == 0){
      document.querySelector('#product-loop').style.grid= "unset";
    }else{
      document.querySelector('#product-loop').style.grid= "grid";
    }
    updateDiscount();
  },1000)
  document.querySelector('.quiz_root').parentElement.style.background = 'unset';
  if(document.querySelector('.quiz__wrapper').style.display == "none"){
    document.querySelector('.quiz_root').style.backgroundColor = "white";
    if(screen.width < 1366){
      document.querySelector('.shopify-section').style.background="white";
    }
  }
  
  
}

let recprd;
function showRecom() {
      recprd = document.querySelectorAll('.product-card-wrapper').length;
      document.querySelector('.user_prd_rec').innerHTML = "we recommend these," + recprd + " to suit your style"; 
}

let userNameInput;


function showName() {
  if(document.querySelectorAll('.action_step_btn')[1].getAttribute('data-goto') == 2){
    let name_btn = document.querySelectorAll('.action_step_btn')[1];
    name_btn.addEventListener("click", function(){
      userNameInput = document.getElementById('quiz_input_input').value;
      document.querySelector('.user_username').innerHTML = "hi " + userNameInput;
      
    })
  }
}

function insertAfter(referenceNode, newNode) {
    referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

function splitQuestion(){
  try{
    let quesObj = JSON.parse(document.querySelector('.watchAdvisorQue').getAttribute('content'));
    document.querySelector('.watchAdvisorQue').innerText = quesObj.firstQue; 
    let el = document.createElement("h5");
    el.style.gridArea = "2 / 1 / 3 / 3";
    el.classList.add('watchAdvisorQue');
    el.innerText = quesObj.SecondQue;
    let div = document.querySelectorAll('.option_item')[1];
    insertAfter(div, el);
  }catch(err){}
}

function addImageChangeEvent(){
  document.querySelectorAll('.option_item').forEach(option=>{
  	option.addEventListener('click',(event)=>{
  		if(!String(event.target.closest('.option_item').classList).includes('quiz_option_selected')){
  			event.target.closest('.option_item').querySelector('img').src = `${JSON.parse(event.target.closest('.option_item').querySelector('img').getAttribute('src-cus')).Selected}`
  		}else{			
  			event.target.closest('.option_item').querySelector('img').src = `${JSON.parse(event.target.closest('.option_item').querySelector('img').getAttribute('src-cus')).defaultIcon}`
  		}
  	})
  })
}

function loadOptionImage(){
  document.querySelectorAll('.option_item img').forEach(e=>{
    if(e.closest('.quiz_option_selected')) e.src = `${JSON.parse(e.getAttribute('src-cus')).Selected}`
  	else e.src = `${JSON.parse(e.getAttribute('src-cus')).defaultIcon}`
  })
}

function hidePrev(){
  if(document.querySelector('[data-type="prev"]').getAttribute('data-goto') == 0) document.querySelector('[data-type="prev"]').style.display = 'none';
}

function changeClock(){
  if(document.querySelector('.watchAdvisorQue').innerText === "What is your Budget?"){
    try{
         document.querySelectorAll('.option_item').forEach(option=>{
        let valueJson = JSON.parse(option.querySelector('label').innerText);
        option.querySelector('label').innerText = valueJson.value;
        option.addEventListener('click',(event=>{
          localStorage.setItem('priceRange',valueJson.range)
        }))
      })
    }catch(err){
      
    }
 
  }
 if(screen.width > 650){
   document.querySelector('.mobClockImg').style.display = 'none';   
    document.querySelectorAll('.quiz-watch-progresser .deskClockImg').forEach(img=>{
      if(img.getAttribute('data-seq') == document.querySelector('[data-type="next"]').getAttribute('data-goto')) { if(document.querySelector('.quiz__wrapper').style.display != 'none') img.style.display  = 'block'; else img.style.display  = 'none'; }
      else img.style.display  = 'none';      
    });
 }else{
   document.querySelector('.deskClockImg').style.display = 'none';
    document.querySelectorAll('.quiz-watch-progresser .mobClockImg').forEach(img=>{
      if(img.getAttribute('data-seq') == document.querySelector('[data-type="next"]').getAttribute('data-goto')) { if(document.querySelector('.quiz__wrapper').style.display != 'none') img.style.display  = 'block'; else img.style.display  = 'none'; }
      else img.style.display  = 'none';      
    });
 }

}
